<template>
  <div>
    <b-table style="margin-top: 30px" id="table_passages_coureur" responsive small :tbody-tr-class="row_arrivee" :items="displayedPassage" :fields="fields">
      <template #cell(distance_depuis_depart)="row">
        <span v-if="row.item.distance_depuis_depart !== '' && row.item.distance_depuis_depart !== '0' && row.item.nom_affiche != 'Arrivée'">KM {{ Math.round(row.item.distance_depuis_depart) }}</span>
        <span v-else></span>
      </template>
      <template #cell(nom_affiche)="row">
        <b>{{ row.item.nom_affiche }}</b>
      </template>

      <template #cell(heure)="row">
        <span v-if="row.item.heure !== '' && row.item.heure !== '00:00:00'">{{ row.item.heure }}</span>
        <span v-else-if="row.item.estimate && row.item.estimate != '' && !statut.course_end && statut.depart" class="primary_color">{{ $t("estime") }} : {{ row.item.estimate }}</span>
        <span v-else>-</span>
      </template>
      <template #cell(temps_intermediaire)="row">
        <span v-if="row.item.temps_intermediaire !== '' && row.item.temps_intermediaire !== '00:00:00' && row.item.heure !== ''">{{ row.item.temps_intermediaire }}</span>
        <span v-else>-</span>
      </template>
      <template #cell(temps_passage)="row">
        <span v-if="row.item.temps_passage !== '' && row.item.temps_passage !== '00:00:00' && row.item.heure !== ''">{{ row.item.temps_passage }}</span>
        <span v-else>-</span>
      </template>
      <template #cell(classement_scratch)="row">
        <p class="text-nowrap" v-if="row.item.classement_scratch !== '0' && row.item.classement_scratch !== 0 && row.item.classement_scratch !== ''">
          {{ row.item.classement_scratch }}

          <v-icon class="icon_differentiel differentiel_up" name="arrow-up" aria-hidden="true" v-if="row.item.differentiel_scratch > 0" />
          <v-icon class="icon_differentiel differentiel_down" name="arrow-down" aria-hidden="true" v-else-if="row.item.differentiel_scratch < 0" />
          <v-icon class="icon_differentiel differentiel_equal" name="equals" aria-hidden="true" v-else />
          <span class="val_differentiel" v-if="row.item.differentiel_scratch != 0">{{ Math.abs(row.item.differentiel_scratch) }}</span>
        </p>
        <p v-else>-</p>
      </template>
      <template #cell(classement_sexe)="row">
        <p class="text-nowrap" v-if="row.item.classement_sexe !== '0' && row.item.classement_sexe !== 0 && row.item.classement_sexe !== ''">
          {{ row.item.classement_sexe }}

          <v-icon class="icon_differentiel differentiel_up" name="arrow-up" aria-hidden="true" v-if="row.item.differentiel_sexe > 0" />
          <v-icon class="icon_differentiel differentiel_down" name="arrow-down" aria-hidden="true" v-else-if="row.item.differentiel_sexe < 0" />
          <v-icon class="icon_differentiel differentiel_equal" name="equals" aria-hidden="true" v-else />
          <span class="val_differentiel" v-if="row.item.differentiel_sexe != 0">{{ Math.abs(row.item.differentiel_sexe) }}</span>
        </p>
      </template>
      <template #cell(classement_cat)="row">
        <p class="text-nowrap" v-if="row.item.classement_cat !== '0' && row.item.classement_cat !== 0 && row.item.classement_cat !== ''">
          {{ row.item.classement_cat }}

          <v-icon class="icon_differentiel differentiel_up" name="arrow-up" aria-hidden="true" v-if="row.item.differentiel_cat > 0" />
          <v-icon class="icon_differentiel differentiel_down" name="arrow-down" aria-hidden="true" v-else-if="row.item.differentiel_cat < 0" />
          <v-icon class="icon_differentiel differentiel_equal" name="equals" aria-hidden="true" v-else />
          <span class="val_differentiel" v-if="row.item.differentiel_cat != 0">{{ Math.abs(row.item.differentiel_cat) }}</span>
        </p>
      </template>
    </b-table>
    <hr />
  </div>
</template>

<script>
export default {
  props: ["passages", "statut"],
  data() {
    return {
      fields: [
        {
          key: "distance_depuis_depart",
          sortable: false,
          label: "Distance",
        },
        {
          key: "nom_affiche",
          sortable: false,
          label: "Nom",
        },
        {
          key: "heure",
          sortable: false,
          label: this.$t("heure_passage"),
        },
        {
          key: "temps_intermediaire",
          sortable: false,
          label: this.$t("temps_inter"),
        },
        {
          key: "temps_passage",
          sortable: false,
          label: this.$t("temps_course"),
        },
        {
          key: "classement_scratch",
          sortable: false,
          label: this.$t("scratch"),
        },
        { key: "classement_sexe", sortable: false, label: this.$t("sexe") },
        { key: "classement_cat", sortable: false, label: this.$t("cat") },
      ],
    };
  },
  methods: {
    row_arrivee(item, type) {
      if (!item || type !== "row") return;
      if (item.nom.includes("Arrivée")) return "row-arrivee";
    },
  },
  computed: {
    displayedPassage() {
      var passages = [];
      if (this.passages.length > 1) {
        passages = this.passages;
        passages = passages.slice(1);
        for (var i = 0; i < passages.length; i++) {
          if (i > 0) {
            var last_index = i - 1;
            passages[i].differentiel_scratch = passages[last_index].classement_scratch - passages[i].classement_scratch;
            passages[i].differentiel_sexe = passages[last_index].classement_sexe - passages[i].classement_sexe;
            passages[i].differentiel_cat = passages[last_index].classement_cat - passages[i].classement_cat;
          } else {
            passages[i].differentiel_scratch = 0;
            passages[i].differentiel_sexe = 0;
            passages[i].differentiel_cat = 0;
          }
          console;
        }
      }
      return passages;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>